import { createAuthClient } from "better-auth/react";
import { genericOAuthClient } from "better-auth/client/plugins";

const baseURL =
  typeof window !== "undefined"
    ? `${window.location.origin}/api/auth`
    : "http://localhost:3100/api/auth";

export const authClient = createAuthClient({
  baseURL,
  plugins: [genericOAuthClient()],
});
